import ng from 'angular';
import { Beneficiostrabalhadores } from '../../../../Beneficiostrabalhadores/beneficiostrabalhadores.service';
import { IRescisao } from '../../models/rescisao.model';

export class MeurhBeneficiosDescontarRescisaoFormController implements ng.IController {

    static $inject = [
        '$scope',
        '$stateParams',
        'Beneficiostrabalhadores',
    ];

    public tipo: string;
    public entity: IRescisao;
    public action: string;
    public busy = false;

    constructor(
        private $scope: angular.IScope,
        private $stateParams: angular.ui.IStateParamsService,
        private BeneficiosTrabalhadoresService: Beneficiostrabalhadores,
    ) {
        this.tipo = this.$stateParams.tipo ?? '-1';

        this.$scope.$on('update_list_beneficiostrabalhadores_component', (event, args: string) => {
            this.busy = true;
            this.BeneficiosTrabalhadoresService.constructors.trabalhador = args;
            this.entity.beneficiostrabalhadores = this.BeneficiosTrabalhadoresService.reload();
        });

        this.$scope.$on('beneficiostrabalhadores_list_finished', () => {
            this.busy = false;
        });
    }
}
